// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

body {
    margin: 0 auto;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    font-size: 1.2vh;
    background-color: #000;
}

.ui {
    display: block;
    z-index: -1000 !important;
    opacity: 0;
    pointer-events: none;
}

.ui.active {
    z-index: 0 !important;
    opacity: 1;
    pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,mBAAmB;AACvB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0 auto;\n    overflow: hidden;\n    width: 100vw;\n    height: 100vh;\n    font-size: 1.2vh;\n    background-color: #000;\n}\n\n.ui {\n    display: block;\n    z-index: -1000 !important;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.ui.active {\n    z-index: 0 !important;\n    opacity: 1;\n    pointer-events: all;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
